import React from 'react';
import { v4 as uuid } from 'uuid';
import { Desktop, Mobile, Tag, Tooltip } from 'esa-ui-library';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { PropertyType } from '../../../common';
import styles from './RowProvider.module.scss';
import iconWidget from '../../../common/images/widget_play.svg';
import iconLobby from '../../../common/images/lobby_play.svg';
import { find } from 'lodash';
import { devicesMap, sessionsListMap } from './PlayerSessions.const';
import wallet from '../../../common/images/wallet.svg';
import arrows from '../../../common/images/arrow-path-rounded-square.svg';

export const getRows = (
	sessions: PropertyType[],
	onSelect: (action: string, session: PropertyType) => void,
	columns: string[]
): PropertyType[] => {
	const getTextClass = (value: number) => {
		let textClass = 'Base';
		if (value > 0) {
			textClass = 'Success';
		} else if (value < 0) {
			textClass = 'Danger';
		}
		return textClass;
	};

	const getActiveCells = (s: PropertyType): PropertyType[] => {
		const rows: PropertyType[] = [];
		columns.forEach((column) => {
			const field = find(sessionsListMap, ['label', column])?.key;
			const cellsMap = {
				session_id: (
					<span key={uuid()} className={styles.Link}>
						{s.session_id}
					</span>
				),
				player_id: (
					<span key={uuid()}>
						<Link
							to={`/players/player-list/${s.player_id}`}
							target='_blank'
							rel='noopener noreferrer'
							className={styles.Link}
						>
							{s.player_id}
						</Link>
					</span>
				),
				external_player_id: <span key={uuid()}>{s.external_player_id}</span>,
				partner: <span key={uuid()}>{s.partner}</span>,
				skin: <span key={uuid()}>{s.skin}</span>,
				game_provider_name: <span key={uuid()}>{s.game_provider_name}</span>,
				game_name: (
					<span key={uuid()} style={{ whiteSpace: 'nowrap' }}>
						<Tooltip position='right' text={s.game_id}>
							<span>{s.game_name}</span>
						</Tooltip>
					</span>
				),
				device: (
					<span key={uuid()} className={styles.DataIcon}>
						<Tooltip position='top' text={`${s.device} - ${devicesMap[s.platform] || s.platform}`}>
							{s.device === 'desktop' ? <Desktop /> : <Mobile />}
						</Tooltip>
					</span>
				),
				widget: (
					<span key={uuid()} className={styles.DataIcon}>
						<Tooltip position='top' text={`${s.widget}`}>
							<img src={s.widget === 'Widget' ? iconWidget : iconLobby} alt='source' width='25' />
						</Tooltip>
					</span>
				),
				session_type: (
					<span key={uuid()} className={styles.DataIcon}>
						{s.session_type ? (
							<Tooltip position='top' text={s.session_type}>
								<img src={s.session_type === 'seamless' ? arrows : wallet} alt='source' width='25' />
							</Tooltip>
						) : (
							'- -'
						)}
					</span>
				),
				session_status: (
					<span key={uuid()} className={cx(styles.Status, styles.DataIcon)}>
						<Tag text={s.session_status} className={styles[s.session_status]} />
					</span>
				),
				nrhands: (
					<span
						key={uuid()}
						className={cx(styles.Bet, styles.DataIcon)}
						onClick={() => onSelect('transaction_details', s)}
						data-testid='transaction-details-btn'
					>
						<Tag text={s.nrhands} className={s.nrhands > 0 ? styles.TagPositive : styles.Tag} />
					</span>
				),
				currency: <span key={uuid()}>{s.currency}</span>,
				bet: (
					<span key={uuid()} className={styles.DataAmount}>
						{s.bet}
					</span>
				),
				ggr: (
					<span key={uuid()} className={`${styles.DataAmount} ${styles[getTextClass(s.ggr)]}`}>
						{s.ggr}
					</span>
				),
				wrb: <span key={uuid()}>{s.wrb}</span>,
				bonus_used: (
					<span key={uuid()} className={styles.DataAmount}>
						{s.bonus_used}
					</span>
				),
				aams_ticket_id: <span key={uuid()}>{s.aams_ticket_id}</span>,
				thirdparty_session_id: <span key={uuid()}>{s.thirdparty_session_id}</span>,
				ip: <span key={uuid()}>{s.ip}</span>,
				session_start: <span key={uuid()}>{s.session_start}</span>,
				session_end: <span key={uuid()}>{s.session_end}</span>,
			};
			if (field) {
				rows.push((cellsMap as Record<string, JSX.Element>)[field]);
			}
		});
		return rows;
	};

	const data = sessions.map((s) => getActiveCells(s));

	return data;
};
